import dynamic from "next/dynamic";
import cx from "classnames";
import { COMPONENTS_BY_TYPE } from "components/templates";

const DYNAMIC_COMPONENTS = {
  CheckoutForm: dynamic(() => import("components/checkout/CheckoutForm")),
  PastBoxes: dynamic(() => import("components/checkout/CheckoutPastBoxes")),
  GiftPersonalizationForm: dynamic(() =>
    import("components/checkout/CheckoutPersonalizationForm")
  ),
  SubModalWhatsIncluded: dynamic(() =>
    import("components/checkout/CheckoutSubModalWhatsIncluded")
  ),
  ConfirmationNotice: dynamic(() =>
    import("components/checkout/CheckoutConfirmationNotice")
  ),
  HowDidYouHearForm: dynamic(() =>
    import("components/checkout/CheckoutHowDidYouHearForm")
  ),
  OrderSummary: dynamic(() =>
    import("components/checkout/CheckoutOrderSummary")
  ),
  GiftOrderSummary: dynamic(() =>
    import("components/checkout/CheckoutGiftOrderSummary")
  ),
  GetStartedCTA: dynamic(() =>
    import("components/checkout/CheckoutGetStartedCTA")
  ),
  CustomizeTimelineCTA: dynamic(() =>
    import("components/checkout/CheckoutCustomizeTimelineCTA")
  ),
  AnnualCustomizeTimelineCTA: dynamic(() =>
    import("components/checkout/CheckoutCustomizeTimelineCTA")
  ),
  AddSubscriptionCTA: dynamic(() =>
    import("components/checkout/CheckoutAddSubscriptionCTA")
  ),
  AddGiftCTA: dynamic(() => import("components/checkout/CheckoutAddGiftCTA")),
  ChooseGift: dynamic(() => import("components/checkout/CheckoutChooseGift")),
  GiftDetails: dynamic(() => import("components/checkout/CheckoutGiftDetails")),
  GiftCheckoutForm: dynamic(() =>
    import("components/checkout/CheckoutGiftForm")
  ),
  GiftSubWhatsIncluded: dynamic(() =>
    import("components/gifts/GiftSubWhatsIncluded")
  ),
  ...COMPONENTS_BY_TYPE,
};

export const DynamicComponent = (props) => {
  const name = props.entry.component || props.entry.type;
  const Component = DYNAMIC_COMPONENTS[name];

  if (Component) {
    return (
      <Component
        {...props}
        className={cx({ "bg-bgBase": name === "FAQ" }, props.className)}
      />
    );
  }
  return null;
};
